import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  className?: string;
}

const PodiumStandbyButton: React.FC<IParams> = ({ className }) => {
  const rootStore = useContext(RootStoreContext);
  const { showPodiumStandby } = rootStore.podiumStore;
  const [t] = useTranslation(["podium"], translationHookOptions);
  
  return (
    <>
      <div className={className}>
        <Button
          color=""
          className="podium-generic-btn"
          onClick={showPodiumStandby}
        >
          <i className="far fa-2x fa-image"></i>
          {t("standby_btn")}
        </Button>
      </div>
    </>
  );
};

export default observer(PodiumStandbyButton);
